import React from 'react';
import { Stack } from '@chakra-ui/react';
import HeroPanelCard from '@components/molecules/HeroPanelCard';

const HeroPanelBlock = ({ data = {} }) => {
  const { elements } = data;

  return (
    <Stack
      spacing="0"
      direction={{ base: `column`, lg: `row` }}
      mb={{ base: `14`, md: `16` }}>
      {elements.map((element, i) => {
        const elementData = {
          ...element,
          content: element.content.data.content
        };

        return (
          <HeroPanelCard key={elementData.id} index={i} data={elementData} />
        );
      })}
    </Stack>
  );
};

export default HeroPanelBlock;
